import { render, staticRenderFns } from "./ParticipantSwapsRiseMapItem.vue?vue&type=template&id=3016a1b4&"
import script from "./ParticipantSwapsRiseMapItem.vue?vue&type=script&lang=js&"
export * from "./ParticipantSwapsRiseMapItem.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantSwapsRiseMapItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
